<template>
    <Head title="New Password" />
    <GuestLayout :showExtras="false" headingTitle="Esqueci Minha Senha" :showBottomBarInDesktop="true">

            <article>
                <div class="mt-8 sm:px-5 xl:max-w-[350px] xl:min-w-[350px]">
                    <h2 class="text-3xl pb:text-hover sm:text-primary font-semibold text-left sm:py-4">Nova Senha</h2>
                    <p class="mt-2 text-md pb-4 pb:text-white">Crie uma <strong>senha</strong> forte que só você
                        <br /> saiba. Ela precisa ter:</p>

                    <ul>
                        <li class="flex items-center pb-1">
                            <Icon :name="isValid(hasTenChar)"/>
                            <p class="ml-2.5 text-sm pb:text-white">Mínimo de 10 caracteres</p>
                        </li>

                        <li class="flex items-center pb-1">
                            <Icon :name="isValid(hasUpperCase)" />
                            <p class="ml-2.5 text-sm pb:text-white">Um caractere maiúsculo</p>
                        </li>

                        <li class="flex items-center pb-1">
                            <Icon :name="isValid(hasLowerCase)" />
                            <p class="ml-2.5 text-sm pb:text-white">Um caractere minúsculo</p>
                        </li>

                        <li class="flex items-center pb-1">
                            <Icon :name="isValid(hasNumber)" />
                            <p class="ml-2.5 text-sm pb:text-white">Um número</p>
                        </li>

                        <li class="flex items-center">
                            <Icon :name="isValid(hasSpecialChar)" />
                            <p class="ml-2.5 text-sm pb:text-white">Um caractere especial (ex.: !@#$%)</p>
                        </li>
                    </ul>


                    <form @submit.prevent="submit" class="mb-4">
                        <ul class="pt-6">
                            <li class="mb-4">
                                <label class="mb-1 mr-5 flex font-bold pb:text-white">Senha</label>
                                <Input
                                    placeholder="*********"
                                    :state="inputState"
                                    id="password"
                                    v-model="form.password"
                                    type="password"
                                    required
                                    autofocus
                                />
                                <p class="text-[10px] pb:text-white">
                                    Força da senha:
                                    <span :class="powerPassword.classes">{{ powerPassword.text }}</span>
                                </p>
                            </li>

                            <li class="mb-8">
                                <label class="mb-1 mr-5 flex font-bold pb:text-white">Confirme sua senha</label>
                                <Input
                                    placeholder="*********"
                                    id="confirmPassword"
                                    :state="isEqualInputState"
                                    v-model="confirmPassword"
                                    type="password"
                                    required
                                    autofocus
                                />
                                <p v-if="!isEqual" class="text-[10px] text-error">
                                    Senhas não coincidem
                                </p>
                                <p v-if="isEqual" class="text-[10px] pb:text-white">
                                    Força da senha:
                                    <span :class="powerPassword.classes">{{ powerPassword.text }}</span>
                                </p>
                            </li>

                            <li>
                                <Button
                                 :enabled="allIsValid && isEqual"
                                    >
                                    Criar Senha
                                </Button>
                            </li>
                <transition>
                    <div v-if="$page.props.flash.success" class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-70 flex justify-center items-center">
                        <div class="bg-white border-[1px] rounded-[4px] mx-2.5 max-w-[350px] w-full px-4 py-4 leading-9">
                            <button class="float-right" @click="$page.props.flash.success = ''">
                                <Icon name="Fechar"/>
                            </button>
                            <h1 class="text-[20px] font-bold text-primary">Sucesso</h1>
                            <p class="text-[16px] leading-6">Sua senha foi alterada!</p>
                            <div class="flex justify-center mt-4">
                                <a href="/login">
                                  <Button type="button">
                                    Fazer login
                                  </Button>
                                </a>
                                <!-- <Button class="w-5/12 my-2 place-self-center" @click.prevent="window.location.href='/login'">Fazer login</Button> -->
                            </div>
                        </div>
                    </div>
                </transition>
                        </ul>
                    </form>

                    <div class="pb:text-white" v-if="$page.props.flash.error">
                        {{ $page.props.flash.error }}
                    </div>

                    <!-- <div v-if="$page.props.flash.success">
                        {{ $page.props.flash.success }}
                    </div> -->
                </div>


            </article>
    </GuestLayout>
</template>
<script>
import Input from "@/Components/UI/Form/Input.vue";
import Button from "@/Components/Button.vue";
import Icon from '@/Components/UI/Icons/Icon.vue'
import GuestLayout from "@/Layouts/Guest.vue";
import { Head } from "@inertiajs/inertia-vue3";

export default {
  components: {
    GuestLayout,
    Head,
    Input,
    Icon,
    Button
  },
  data() {
    return {
        showSuccessModal: false,
        showModal: true,
        confirmPassword: '',
        form: this.$inertia.form({
          email: sessionStorage.getItem('recoveryEmail'),
          code: sessionStorage.getItem('code'),
          password: ''
        }),

    }

  },
  methods: {
    submit() {
        if(this.allIsValid && this.isEqual){
            // this.showSuccessModal = true;
        this.$inertia.post('/forgot-password/new-password', this.form, {
            onSuccess: () => {
              this.showSuccessModal = true;
              sessionStorage.clear();
            }
          });
            sessionStorage.clear();

        }

    },
    isValid(fn) {
      if(fn) {
        return 'Sucesso'
      } else {
        return 'Erro'
      }
    },
  },
  computed: {
    hasTenChar() {
      return this.form.password.length > 9;
    },
    hasUpperCase() {
      var re = /([A-Z])/g
      return re.test(this.form.password);
    },
    hasLowerCase() {
      var re = /([a-z])/g
      return re.test(this.form.password);
    },
    hasNumber() {
      var re = /([0-9])/g
      return re.test(this.form.password);
    },
    hasSpecialChar() {
      var re = /[^A-Za-z0-9]/
      return re.test(this.form.password);
    },
    isEqual() {
      return this.form.password === this.confirmPassword;
    },
    allIsValid() {
      return (this.hasTenChar && this.hasUpperCase && this.hasLowerCase && this.hasNumber && this.hasSpecialChar)
    },
    inputState() {
      if(this.form.password) {
        if(this.allIsValid) {
          return 'success'
        } else {
          return 'error'
        }
      }
    },
    isEqualInputState() {
      if(this.form.password) {
        if(this.isEqual) {
          return 'success'
        } else {
          return 'error'
        }
      }
    },
    powerPassword() {
      if(this.allIsValid) {
        return {
          classes: 'text-success',
          text: 'forte'
        }
      }
      else if(this.hasTenChar) {
        return {
          classes: 'text-yellow-300',
          text: 'média'
        }
      }
      else {
        return {
          classes: 'text-error',
          text: 'fraca'
        }
      }
    }
  }
}
</script>
